<ng-container *transloco="let t; read: 'user'">
<drdp-dashboard-search [displayDropdowns]="displayDropdowns" [requiredFields]="requiredFields"
  [title]="t('stateDashboard.export.specialEducationTitle')" (exportClicked)="handleSearch($event)">
</drdp-dashboard-search>
</ng-container>
